import { createAction, props } from '@ngrx/store';
import { Product } from '@common/product';
import { SearchCriteria } from '@shop/services/shop.service';

// Acciones para la carga de productos
export const loadProducts = createAction(
  '[Products] Load Products',
  props<{ criteria: SearchCriteria }>()
);

export const loadProductsSuccess = createAction(
  '[Products] Load Products Success',
  props<{ products: Product[], totalElements: number }>()
);

export const loadProductsFailure = createAction(
  '[Products] Load Products Failure',
  props<{ error: any }>()
);
